module.exports = __webpack_public_path__ + "static/media/Icon.34a07570.jpg";